module.exports = __webpack_public_path__ + "img/scervice-10.e16afbef.gif";